import { MiniWishlist } from './MiniWishlist.ts';
import { ToggleBox } from '../shared/toggleBox.js';
import { eventLoader } from '@otto-ec/global-resources/event-loader';

import '../../scss/miniWishlist/main.scss';

const toggles = new ToggleBox(document.querySelector('.wl_toggleInfo'));
/*                                                                                               */
const element = document.querySelector('.wl_mini__link') ?? document.querySelector('.wl_mini-wishlist');

eventLoader.onAllScriptsExecuted(10, () => {
    new MiniWishlist(element, toggles).init();
});
